import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import FormatUtils from '../common/formatUtils/FormatUtils';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import { setError } from '../common/toast/toast';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ThSort from '../common/table/thSort';
import SelectDefault from '../common/form/selectDefault';
import DateFormat from '../common/dateFormat/DateFormat';
import ColorUtils from '../common/colorUtils/ColorUtils';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import ButtonTable from '../common/table/buttonTable';
import consts from '../consts';

import {
	setModoTela, initForm
} from './pendenciaActions';

class PendenciaForm extends Component {

	state = {

	}

	render() {

		const setor = this.props.listaSetor.filter(setor => setor.id == this.props.formularioValues.id_setor)[0] || {};

		let readOnly = this.props.excluir || this.props.resolver || this.props.formularioValues.resolvida ? 'readOnly' : '';

		const incluido = !!this.props.formularioValues.id;

		return (
			<>
				<ContentCard>
					<Form event={this.props.handleSubmit}>
						<ContentCardBody>
							<Row>
								<Select
									name='id_tipo'
									options={this.props.listaPendenciaTipo}
									label='Pendência'
									cols='12 12 12 12'
									placeholder='Selecione'
									readOnly={incluido ? 'readOnly' : readOnly}
									value={this.props.formularioValues.id_tipo}
									onChange={value => {
										const tipo = this.props.listaPendenciaTipo.filter(item => item.id == value)[0];

										this.props.initForm({
											...this.props.formularioValues,
											id_tipo: tipo ? tipo.id : null,
											id_setor: tipo ? tipo.id_setor : null,
											obrigatoria: tipo ? tipo.obrigatoria : false
										});
									}} />

								{this.props.formularioValues.id_controle_patio_ficha_tipo == 1 &&
								<>
									{incluido ? (
										<Field
											name='id_motorista'
											options={this.props.listaMotorista}
											component={Select}
											label='Motorista'
											cols='12 12 12 12'
											placeholder='Selecione'
											readOnly={incluido ? 'readOnly' : readOnly} />
									) : (
										<Select
											options={this.props.listaMotorista}
											label='Motorista'
											cols='12 12 12 12'
											placeholder='Selecione'
											multiple
											value={this.props.formularioValues.ids_motoristas}
											onChange={values => {
												this.props.initForm({
													...this.props.formularioValues,
													ids_motoristas: values.map(item => item.value)
												});
											}} />
									)}
								</>}

								{this.props.formularioValues.id_controle_patio_ficha_tipo == 2 &&
								<>
									{incluido ? (
										<Field
											name='cavalo'
											options={this.props.listaCavalo}
											component={Select}
											label='Cavalo'
											cols='12 12 12 12'
											placeholder='Selecione'
											readOnly={incluido ? 'readOnly' : readOnly} />
									) : (
										<Select
											options={this.props.listaCavalo}
											label='Cavalos'
											cols='12 12 12 12'
											placeholder='Selecione'
											multiple
											value={this.props.formularioValues.cavalos}
											onChange={values => {
												this.props.initForm({
													...this.props.formularioValues,
													cavalos: values.map(item => item.value)
												});
											}} />
									)}
								</>}

								{this.props.formularioValues.id_controle_patio_ficha_tipo == 3 &&
								<>
									{incluido ? (
										<Field
											name='carreta'
											options={this.props.listaCarreta}
											component={Select}
											label='Carreta'
											cols='12 12 12 12'
											placeholder='Selecione'
											readOnly={incluido ? 'readOnly' : readOnly} />
									) : (
										<Select
											options={this.props.listaCarreta}
											label='Carretas'
											cols='12 12 12 12'
											placeholder='Selecione'
											multiple
											value={this.props.formularioValues.carretas}
											onChange={values => {
												this.props.initForm({
													...this.props.formularioValues,
													carretas: values.map(item => item.value)
												});
											}} />
									)}
								</>}

								{!this.props.formularioValues.id_controle_patio_ficha_tipo &&
								<Field
									name='shipping'
									component={LabelAndInput}
									minWidth={200}
									label='Shipping' placeholder='Informe'
									cols='12 1 1 1'
									readOnly={incluido ? 'readOnly' : readOnly} />}

								<Field
									name='observacao'
									component={LabelAndInput}
									label='Observação' placeholder='Informe'
									cols='12 12 12 12'
									readOnly={readOnly} />

								<Field
									name='obrigatoria'
									component={LabelAndCheckbox}
									label='Obrigatória' placeholder='Informe'
									cols='12 12 12 12'
									readOnly={['SUPERVISOR', 'GESTOR'].includes(setor.permissao) ? readOnly : 'readOnly'} />

								<LabelAndInputDate
									label='Data Máxima'
									cols='12 6 4 4'
									value={this.props.formularioValues.data_maxima}
									readOnly={!this.props.formularioValues.id || ['SUPERVISOR', 'GESTOR'].includes(setor.permissao) ? readOnly : 'readOnly'}
									onChange={value => {
										this.props.initForm({
											...this.props.formularioValues,
											data_maxima: value
										});
									}} />
							</Row>
						</ContentCardBody>
						<ContentCardFooter>
							<Row alignCenter>
								<Grid cols='6 6 4 3'>
									{this.props.excluir ? (
										<Button
											text='Excluir'
											submit type={'danger'}
											icon={'fa fa-trash'} />
									) : (
										<Button
											text={this.props.resolver ? 'Resolver' : 'Salvar'}
											submit
											type={'success'}
											icon={'fa fa-check'}
											disabled={!['USUARIO', 'SUPERVISOR', 'GESTOR'].includes(setor.permissao)} />
									)}
								</Grid>
								<Grid cols='6 6 4 3'>
									<Button
										text='Voltar'
										type={'warning'}
										icon={'fa fa-chevron-left'}
										event={() => this.props.setModoTela('lista')} />
								</Grid>
							</Row>
						</ContentCardFooter>
					</Form>
				</ContentCard>

				{this.listaLogs()}
			</>
		);
	}

	listaLogs() {

		if (!this.props.listaLog.length) {
			return null;
		}

		return (
			<ContentCard>
				<ContentCardHeader>
					<h3 class='card-title'>Logs</h3>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive border striped>
						<THead>
							<Tr backgroundColor={'#1F3066'}
								color={'#ffffff'}
								height={47}>
								
								<ThSort
									field='datahora'
									label='Data/Hora'
									width={100}
									sticky />

								<ThSort
									field='operacao'
									label='Operação'
									width={100}
									sticky />

								<ThSort
									field='nome_status'
									label='Status'
									width={100}
									sticky />
									
								<ThSort
									field='nome_tipo'
									label='Pendência'
									width={200}
									sticky />		

								<ThSort
									field='Setor'
									label='Setor'
									width={100}
									sticky/>		

								<ThSort
									field='nome'
									label='Nome / Placa / Shipping'
									width={300}
									sticky />		

								<ThSort
									field='obrigatoria'
									label='Obrigatória'
									width={10}
									sticky />		
									
								<ThSort
									field='data_maxima'
									label='Data Máxima'
									width={100}
									sticky />
									
								<ThSort
									field='nome_usuario'
									label='Usuário'
									width={100}
									sticky />
							</Tr>
						</THead>
						<TBody>
							{this.props.listaLog.map((item, i) => {
								return (
									<Tr key={item.id}
										backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora)}</Td>
										<Td color={'#000'} alignCenter small>{item.operacao}</Td>
										<Td color={'#000'} alignCenter small>{item.nome_status}</Td>
										<Td color={'#000'} alignCenter small>{item.nome_tipo}</Td>
										<Td color={'#000'} alignCenter small>{item.nome_setor}</Td>
										<Td color={'#000'} alignCenter small>{item.nome_motorista || item.cavalo || item.carreta || item.shipping}</Td>
										<Td color={'#000'} alignCenter small>{item.obrigatoria ? 'Sim' : 'Não'}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataSqlParaTela(item.data_maxima)}</Td>
										<Td color={'#000'} alignCenter small>{item.nome_usuario}</Td>										
									</Tr>
								);
							})}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}
	
}

PendenciaForm = reduxForm({ form: 'pendenciaForm', destroyOnUnmount: false })(PendenciaForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	formularioValues: getFormValues('pendenciaForm')(state),
	registro: state.pendencia.registro,
	listaPendenciaTipo: state.pendenciaTipo.listaSelect.filter(item => {
		const setor = state.setor.listaSelect.filter(setor => setor.id == item.id_setor)[0];

		return setor && (
			(setor.ids_usuarios_completo || []).includes(state.auth.usuario.id)
			|| (setor.ids_usuarios_supervisores_completo || []).includes(state.auth.usuario.id)
			|| (setor.ids_usuarios_gestores_completo || []).includes(state.auth.usuario.id)
		);
	}),
	listaMotorista: state.pendencia.listaMotorista,
	listaCavalo: state.pendencia.listaCavalo,
	listaCarreta: state.pendencia.listaCarreta,
	listaSetor: state.setor.listaSelect.filter(item => {
		return (item.ids_usuarios_completo || []).includes(state.auth.usuario.id)
			|| (item.ids_usuarios_supervisores_completo || []).includes(state.auth.usuario.id)
			|| (item.ids_usuarios_gestores_completo || []).includes(state.auth.usuario.id);
	}).map(item => ({
		...item,
		permissao: (item.ids_usuarios_gestores_completo || []).includes(state.auth.usuario.id) ? 'GESTOR' : (
			(item.ids_usuarios_supervisores_completo || []).includes(state.auth.usuario.id) ? 'SUPERVISOR' : (
				(item.ids_usuarios_completo || []).includes(state.auth.usuario.id) ? 'USUARIO' 
				: 'SEM PERMISSAO'
			)
		)
	})),
	listaLog: state.pendencia.listaLog
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PendenciaForm);